import axios from 'axios'


export const getBons = ({commit,state, rootState},that) => {
    axios.get(rootState.baseurl + '/bondecommandes/byfournisseur/'+rootState.fournisseur.id,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer "+rootState.auth.token
        }
    }).then(res=>{
        console.log('Mes Bons de commandes',res.data.data);
        commit('getBons',res.data.data);
        console.log('that :', that);
        that.$forceUpdate();
    }).catch(err=>{
        console.log('error');
    });
}


export const setOuvertYn = ({state,commit, rootState},bonId)=>{
    axios.get(rootState.baseurl + '/bondecommandes/setouvertyn/'+bonId,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":"Bearer "+rootState.auth.token
        }
    }).then(res=>{
        console.log('setOyvertYn',res.data);
    }).catch(err=>{
        console.log('error',err);
    });
}